import { get } from 'lodash';
import initialState from 'reducers/initialState';
import { MAGIC_ALGORITHM } from 'store/constants';
import * as types from 'actions/actionTypes';

export const buildZipIndex = market => {
  if (market) {
    const zipIndex = [];
    Object.keys(market).forEach(area => {
      const zipRanges = market[area];
      zipRanges.forEach(range => {
        const index = `${range.join(':')}:${area}`;
        zipIndex.push(index);
      });
    });
    return zipIndex;
  }
  return undefined;
};

const reducer = (state = initialState[MAGIC_ALGORITHM], action) => {
  if (action.type === types.GET_MAGIC_ALGORITHM_RESULTS.SUCCESS) {
    const market = get(action, 'payload.market');
    const attribute = get(action, 'payload.attribute');
    const zipIndex = buildZipIndex(market);
    return {
      market,
      attribute,
      zipIndex
    };
  }
  return state;
};

export default reducer;
